import { HttpClient, HttpParams } from '@angular/common/http';
import { WebFamPlace, PlaceTopResult, PlaceSurnamesResult, WebFamPlaceManage, WebFamPlaceAncestor } from '../models/place.model';
import { WebFamUsages } from '../models/common.model';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DialogData } from 'src/app/profile-edit/place-edit/place-edit.component';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class PlaceService {

    constructor(private httpClient: HttpClient) { }

    getPlace(id: string) {
        return this.httpClient.get<WebFamPlace>(environment.backendUrl + '/place/get/tree/' + environment.currentTree + '/id/' + id);
        //.pipe(map(value => Object.assign(new WebFamPlace(), value)));
    }

    async getPlaceAsync(id: number) {
        return await this.httpClient.get<WebFamPlace>(environment.backendUrl + '/place/getPlace/' + id);
    }

    getPlaceList(title: string): Observable<WebFamPlace[]> {
        return this.httpClient.get<WebFamPlace[]>(
            environment.backendUrl + '/place/list/tree/' + environment.currentTree + '/name/' + title
        ); //.pipe(map(value => Object.assign({} as WebFamPlace[], value as WebFamPlace[])));
    }

    getPlaceTree(value: string) {
        return this.httpClient.get<WebFamPlace[]>(
                    environment.backendUrl + '/place/list/tree/' + environment.currentTree + '/parent/' + (value ? value : '')
                );
    }

    getPlaceListById(value: string[]) {
        /*let Params = new HttpParams();
        Params = Params.append('placeIds', value);
*/
        return this.httpClient.get<WebFamPlace[]>(
                    environment.backendUrl + '/place/list/tree/' + environment.currentTree + '/id/' + JSON.stringify(value)
                );
    }

    getTopList(value: string) {
        let params = new HttpParams();
        params = params.append('skip', '0');
        params = params.append('limit', '5');
        return this.httpClient.get<PlaceTopResult[]>(environment.backendUrl + '/place/getTopList/' + value, { params });
    }

    getPlaceSurnames(placeId: string) {
        return this.httpClient.get<PlaceSurnamesResult[]>(
                    environment.backendUrl + '/place/list/surnames/tree/' + environment.currentTree + '/place/' + placeId
                );
    }

    /* --- porządkowanie miejsc (ustawienia drzewa) ------------------------- */

    /** Dzieci danego rodzica (bez argumentu: poziom główny) z licznikami użyć. */
    getPlaceManageList(parentId?: string) {
        return this.httpClient.get<WebFamPlaceManage[]>(
                    environment.backendUrl + '/place/manage/list/tree/' + environment.currentTree
                    + (parentId ? '/parent/' + parentId : '')
                );
    }

    /** Ścieżka od poziomu głównego do miejsca - okruszki nad listą. */
    getPlaceAncestors(placeId: string) {
        return this.httpClient.get<WebFamPlaceAncestor[]>(
                    environment.backendUrl + '/place/manage/path/tree/' + environment.currentTree + '/place/' + placeId
                );
    }

    /** Konkretne miejsca użycia - zdarzenia (z osobami) wskazujące to miejsce. */
    getPlaceUsages(placeId: string) {
        return this.httpClient.get<WebFamUsages>(
                    environment.backendUrl + '/place/manage/usages/tree/' + environment.currentTree + '/place/' + placeId
                );
    }

    /** Scala duplikat z celem - zdarzenia i pod-miejsca przechodzą na cel. */
    mergePlaces(sourceId: string, targetId: string) {
        return this.httpClient.post<{ status: string; message?: string; moved_events?: number; moved_children?: number }>(
                    environment.backendUrl + '/place/merge/tree/' + environment.currentTree
                    + '/source/' + sourceId + '/target/' + targetId, {}
                );
    }

    /** Przenosi miejsce pod innego rodzica (null = poziom główny). */
    reparentPlace(placeId: string, parentId: string | null) {
        return this.httpClient.patch<{ status: string; message?: string }>(
                    environment.backendUrl + '/place/reparent/tree/' + environment.currentTree + '/place/' + placeId,
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    { data: { parent_id: parentId } }
                );
    }

    /** Usuwa miejsce - backend odmawia, gdy ma zdarzenia lub pod-miejsca. */
    removePlace(placeId: string) {
        return this.httpClient.delete<{ status: string; message?: string }>(
                    environment.backendUrl + '/place/remove/tree/' + environment.currentTree + '/place/' + placeId
                );
    }

    formatDisplayPlace(place: WebFamPlace, short: boolean = false): string {
        if ((place !== null) && (typeof place === 'object')) {
            const output = place.places ? short ? place.places[0].location : place.places[0].fullname : '';
            return output.valueOf();
        }
        return '';
    }

    updatePlace(placeData: DialogData) {
        return this.httpClient.patch<string>(
                    environment.backendUrl + '/place/update/tree/' + environment.currentTree + '/place/' + placeData.id,
                    {data: placeData.places}
                );
    }

    insertPlace(placeData: DialogData) {
        return this.httpClient.post<string>(environment.backendUrl + '/place/insert/tree/' + environment.currentTree,
            { data: placeData.places });
    }

}
